import React, { useState, useContext, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import css from "./Research.module.css";
import SAMrect from "../../assets/SAMrect.png";
import SAMrectSelected from "../../assets/SAMrectSelected.png";
import { ANEWBr } from "../../Utils/ANEWBr";
import { Button } from "../Forms/Button";
import { createParticipantFirebase } from "../../Utils/firebaseResearch";
import { ResearchContext } from "../../Context/ResearchContext";

const createMatrix = (rows, cols, value = false) =>
  Array.from({ length: rows }, () => Array(cols).fill(value));

export const Words = () => {
  const { resUser, setResUser, setStartSessionTime } =
    useContext(ResearchContext);
  const navigate = useNavigate();

  const TOTAL_WORDS = 60;
  const SCALE_SIZE = 9;

  const [index, setIndex] = useState(-1);
  const [reactionTime, setReactionTime] = useState(Date.now());
  const [reactionTimeList, setReactionTimeList] = useState(
    new Array(TOTAL_WORDS).fill(0),
  );

  const [WordVal, setWordVal] = useState(() =>
    createMatrix(TOTAL_WORDS, SCALE_SIZE),
  );
  const [SAMale, setSAMale] = useState(() =>
    createMatrix(TOTAL_WORDS, SCALE_SIZE),
  );

  const [secondsRemaining, setSecondsRemaining] = useState(5);
  const [ITI, setITI] = useState(false);
  const [start, setStart] = useState(false);

  /* -----------------------------
     TIMER DO CONTADOR DE 5s
  --------------------------------*/
  useEffect(() => {
    if (!start || secondsRemaining <= 0) return;

    const timer = setTimeout(
      () => setSecondsRemaining((prev) => prev - 1),
      1000,
    );
    return () => clearTimeout(timer);
  }, [start, secondsRemaining]);

  /* -----------------------------
     QUANDO O TEMPO ZERA
  --------------------------------*/
  useEffect(() => {
    if (secondsRemaining === 0 && start) {
      nextWord(); // chama automaticamente sem quebrar o render
    }
  }, [secondsRemaining, start]);

  /* -----------------------------
     Função de seleção do usuário
  --------------------------------*/
  const handleCheck = useCallback(
    (type, col) => {
      const matrix = type === 0 ? WordVal : SAMale;
      const setMatrix = type === 0 ? setWordVal : setSAMale;

      setMatrix((prev) => {
        return prev.map((row, rIndex) => {
          if (rIndex !== index) return row;

          // desmarca qualquer outro
          const updated = Array(SCALE_SIZE).fill(false);
          updated[col] = !row[col]; // toggle
          return updated;
        });
      });

      // reaction time
      setReactionTimeList((prev) => {
        const updated = [...prev];
        updated[index] = Date.now() - reactionTime;
        return updated;
      });
    },
    [index, reactionTime, WordVal, SAMale],
  );

  /* -----------------------------
     Avançar palavra
  --------------------------------*/
  const nextWord = useCallback(() => {
    // Se já marcou 40 palavras → enviar
    if (countSAMChecked() === 40) {
      submit();
      return;
    }

    setITI(true);
    setTimeout(() => setITI(false), 700);

    const nextIndex = index + 1 >= TOTAL_WORDS ? 0 : index + 1;

    setIndex(nextIndex);
    setReactionTime(Date.now());
    setSecondsRemaining(5);
    setStart(true);
  }, [index]);

  /* -----------------------------
     Contar marcações
  --------------------------------*/
  const countSAMChecked = () => {
    return WordVal.flat().filter((v) => v).length;
  };

  /* -----------------------------
     Submissão final
  --------------------------------*/
  const submit = () => {
    const selections = WordVal.map((row, i) => ({
      word: ANEWBr[i],
      // Verifica se 'row' existe antes de tentar ler o 'indexOf'
      valence: row ? row.indexOf(true) + 1 : 0,
      reactionTime: reactionTimeList[i],
    })).filter((item) => item.valence > 0);

    const sorted = [...selections].sort((a, b) => a.valence - b.valence);

    const updatedUser = {
      ...resUser,
      phase: 3,
      WordVal: sorted,
      wordCloudDay1: sorted,
    };

    console.log("updatedUser", updatedUser);
    createParticipantFirebase(updatedUser);
    setResUser(updatedUser);
    setTimeout(() => navigate(`/research/${updatedUser.id}`), 1200);
  };

  /* -----------------------------
     TELAS DE INTERVALO / INÍCIO
  --------------------------------*/
  if (ITI) {
    return (
      <div className={css.container}>
        <div className={css.iti}></div>
      </div>
    );
  }

  if (index < 0) {
    return (
      <div className={css.container}>
        <h1>Avaliar palavras</h1>
        <p>
          A seguir serão apresentadas 40 palavras. Nesta etapa você irá
          classificar cada palavra dentro de uma escala de 1-9 pontos.
        </p>
        <p>
          Para avaliação da valencia, marque o setor da escala que corresponde
          ao quão agradável (mais próximo da palavra "positivo") ou desagradável
          (mais próximo da palavra "negativo") essa palavra te parece.
        </p>
        <p>
          Você terá 5 segundos para avaliar cada palavra. Após terminado o
          tempo, outra palavra será apresentada.
        </p>
        <Button
          onClick={() => {
            setStartSessionTime(true);
            nextWord();
          }}
        >
          Iniciar
        </Button>
      </div>
    );
  }

  /* -----------------------------
     TELA PRINCIPAL
  --------------------------------*/
  return (
    <div className={css.container}>
      <div className={css.samScale}>
        <h1>{ANEWBr[index]}</h1>

        <form className={css.samItens}>
          <strong>NEGATIVO</strong>

          {WordVal[index].map((selected, i) => (
            <label key={i} className={css.wordCheck}>
              <img src={selected ? SAMrectSelected : SAMrect} alt="" />
              <input
                type="checkbox"
                checked={selected}
                onChange={() => handleCheck(0, i)}
              />
            </label>
          ))}

          <strong>POSITIVO</strong>
        </form>
      </div>
    </div>
  );
};
